module.exports = __webpack_public_path__ + "static/media/00_paint_agd-venice.ea3c4b89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/00_paint_agd-venice.jpg
// module id = 272
// module chunks = 0